import { ChevronRight } from "lucide-react";
import { Fragment, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { clsx } from "@/src/common/utils/clsx";

export interface BreadcrumbItem {
	label: ReactNode;
	to?: string;
}

interface BreadcrumbProps {
	items: BreadcrumbItem[];
	className?: string;
}

export function Breadcrumb({ items, className }: BreadcrumbProps) {
	const { t } = useTranslation("common");
	return (
		<nav aria-label={t("aria.breadcrumb")} className={clsx("flex items-center gap-1.5 text-sm", className)}>
			{items.map((item, index) => {
				const isLast = index === items.length - 1;
				return (
					<Fragment key={`${index}-${typeof item.label === "string" ? item.label : index}`}>
						{item.to && !isLast ? (
							<Link to={item.to} className="text-muted-foreground hover:text-foreground">
								{item.label}
							</Link>
						) : (
							<span className={clsx(isLast ? "font-semibold text-foreground" : "text-muted-foreground")}>{item.label}</span>
						)}
						{!isLast ? <ChevronRight className="size-3.5 text-subtle-foreground" aria-hidden /> : null}
					</Fragment>
				);
			})}
		</nav>
	);
}
